import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getStorage, provideStorage } from '@angular/fire/storage';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { APP_ENVIRONMENT } from '@price-management-console/shared-ui';
import { ModuleRegistry } from 'ag-grid-community';
import { AllEnterpriseModule, LicenseManager } from 'ag-grid-enterprise';
import { environment } from '../environments/environment';
import { appRoutes } from './app.routes';
import { tokenInterceptor } from './security/token.interceptor';

import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideAppGridPreferences } from '@price-management-console/preferences';
import { env } from '../env';

ModuleRegistry.registerModules([AllEnterpriseModule]);
LicenseManager.setLicenseKey(environment.AGGRID_LICENSE_KEY);

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(appRoutes, withComponentInputBinding()),
    provideAppGridPreferences(),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => getAuth()),
    provideFirestore(() => getFirestore()),
    provideStorage(() => getStorage()),
    provideHttpClient(
      withInterceptors([
        tokenInterceptor,
        // mockPermissionsInterceptor
      ])
    ),
    importProvidersFrom(
      MatSnackBarModule,
      TranslateModule.forRoot({
        loader: provideTranslateHttpLoader({
          prefix: '/i18n/',
          suffix: '.json',
        }),
      })
    ),
    {
      provide: APP_ENVIRONMENT,
      useValue: {
        ...environment,
        USING_ANGULAR_PROXY: env.USING_ANGULAR_PROXY,
      },
    },
  ],
};
